import React, { useEffect } from 'react';
import './Home.scss';
import { useNavigate } from 'react-router-dom';
import { privatePagesList } from '../../constants/pages';
import { useAuth } from '../../router/AuthContext';

// Somente redireciona para uma página válida
function Home() {
  const { userMenuList } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (userMenuList?.length > 0) {
      navigate(`/${Object.values(privatePagesList)[0].slug}`);
    }
  }, [navigate, userMenuList]);

  return <>{userMenuList?.length == 0 && <>Você não possui permissões</>}</>
}

export default Home;
